import React, { useMemo } from 'react';
import { FixedSizeList } from 'react-window';
import { format, getDay, addDays, subDays, isToday } from 'date-fns';
import { es } from 'date-fns/locale';
import HourCellAndroid from './HourCellAndroid';
import { esFeriadoPeruano } from '../../utils/feriadosPeruanos';

const WeekViewAndroid = ({
  currentDate,
  events,
  onEventClick,
  onDateClick,
  colorConfig,
  selectedEspecialista,
  isHoraBloqueada,
  getUserRole,
}) => {
  const weekDays = useMemo(() => {
    const day = getDay(currentDate);
    const diff = day === 0 ? 6 : day - 1;
    const start = subDays(currentDate, diff);
    const days = [];
    for (let i = 0; i < 6; i++) {
      const d = addDays(start, i);
      if (getDay(d) !== 0) days.push(d);
    }
    return days;
  }, [currentDate]);

  const hours = useMemo(() => {
    const h = [];
    for (let i = 8; i <= 19; i++) {
      h.push(`${i.toString().padStart(2, '0')}:00`);
    }
    return h;
  }, []);

  const getEventsForSlot = (dayIndex, hourIndex) => {
    const day = weekDays[dayIndex];
    const hour = hours[hourIndex];
    const dateStr = format(day, 'yyyy-MM-dd');
    const hourNum = parseInt(hour.split(':')[0]);

    return events.filter(event => {
      const eventDate = typeof event.fecha === 'string' ? event.fecha : format(event.fecha, 'yyyy-MM-dd');
      return eventDate === dateStr && event.horaInicioNum === hourNum;
    });
  };

  const Row = ({ index, style }) => {
    const hour = hours[index];
    return (
      <div style={{ ...style, display: 'flex', gap: 2 }}>
        <div style={{ width: 60, fontSize: 12, textAlign: 'right', paddingRight: 8 }}>
          {hour}
        </div>
        {weekDays.map((day, dayIndex) => {
          const slotEvents = getEventsForSlot(dayIndex, index);
          const dateStr = format(day, 'yyyy-MM-dd');
          const esFeriado = esFeriadoPeruano(dateStr);
          const horarioInfo = selectedEspecialista ? isHoraBloqueada(dateStr, hour, selectedEspecialista) : { laborable: true };

          return (
            <HourCellAndroid
              key={dayIndex}
              events={slotEvents}
              day={day}
              hour={hour}
              esFeriado={esFeriado}
              horarioInfo={horarioInfo}
              onEventClick={onEventClick}
              onDateClick={onDateClick}
              colorConfig={colorConfig}
              getUserRole={getUserRole}
            />
          );
        })}
      </div>
    );
  };

  return (
    <FixedSizeList
      height={600}
      itemCount={hours.length}
      itemSize={60}
      width="100%"
    >
      {Row}
    </FixedSizeList>
  );
};

export default WeekViewAndroid;